import api from '../backend-api.js';
export default {
    getAllCommunities: async (archivedIncluded = false) => {
        return (await api.getData(`/communities?archivedIncluded=${archivedIncluded}`)).data
    },
    createCommunity: async (newCommunity) => {
        return (await api.postData('/communities', newCommunity)).data;
    },
    deleteCommunity: async (community) => {
        return api.deleteData('/communities/' + community.id);
    },
    updateCommunity: async (community) => {
        return api.putData('/communities', community);
    },
    getPatrons: async (communityId) => {
        return (await api.getData('/communities/' + communityId + '/patrons')).data;
    }
};
